module.exports = __webpack_public_path__ + "img/logo-em2.bb73cb02.png";